import {contarPropiedadValor} from "../../Servicios/BD/Contadores/contarPropiedadValor";

export const obtenerClienteDepartamento = async (departamentos = []) => {


    let arrPromesas = []

    for (let i = 0; i < departamentos.length; i++) {
        arrPromesas.push(clientesPorDepartamento(departamentos[i]))
    }

    return Promise.all(arrPromesas)


}

const clientesPorDepartamento = async (departamento) => {

    let result = await contarPropiedadValor({coleccion: 'clientes', propiedad: 'departamento', valor: departamento})

    return {nombre: departamento, cantidad: result.data}

}